export const CHANGE_TYPES = {
  PRICING: 'pricing',
  HOURS: 'hours',
  LAUNCH: 'launch',
  COMPETITOR: 'competitor',
  OTHER: 'other',
};

export const CHANGE_TYPE_OPTIONS = [
  { value: CHANGE_TYPES.PRICING, label: 'Pricing / Promotion Change' },
  { value: CHANGE_TYPES.HOURS, label: 'Operating Hours Change' },
  { value: CHANGE_TYPES.LAUNCH, label: 'Product Launch' },
  { value: CHANGE_TYPES.COMPETITOR, label: 'Competitor Change' },
  { value: CHANGE_TYPES.OTHER, label: 'Other' },
];

export const CHANGE_TYPE_HELPER_TEXT = {
  [CHANGE_TYPES.PRICING]: 'Compare revenue before and after your price or promotion change',
  [CHANGE_TYPES.HOURS]: 'Analyze impact of new operating hours on daily performance',
  [CHANGE_TYPES.LAUNCH]: 'Measure how your new product affected overall business',
  [CHANGE_TYPES.COMPETITOR]: 'Assess how competitor activity impacted your sales',
  [CHANGE_TYPES.OTHER]: 'Analyze the impact of any business change',
};

export const INSIGHT_COLORS = {
  NET_POSITIVE_IMPACT: '#28a745',
  NET_NEGATIVE_IMPACT: '#dc3545',
  REVENUE_SHIFTED: '#ffc107',
  LIKELY_SEASONAL: '#17a2b8',
  MIXED_RESULTS: '#6c757d',
};

export const METRIC_TYPES = {
  REVENUE: 'revenue',
  QUANTITY: 'quantity',
};

export const METRIC_OPTIONS = [
  { value: METRIC_TYPES.REVENUE, label: 'Revenue' },
  { value: METRIC_TYPES.QUANTITY, label: 'Sales Quantity' },
];

export const COMPARISON_PERIOD_OPTIONS = [
  { value: 7, label: 'Up to 7 days before/after' },
  { value: 14, label: 'Up to 14 days before/after' },
  { value: 28, label: 'Up to 28 days before/after' },
  { value: 90, label: 'Up to 90 days before/after' },
  { value: 180, label: 'Up to 180 days before/after' },
  { value: 365, label: 'Up to 365 days before/after' },
];
